/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';
//import { createStyles } from '@material-ui/styles';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
//import themeProject from './cfg/theme.json';

import { green } from '@material-ui/core/colors';

//let appPalette = themeProject.palette

const theme = M.createTheme({
    //  palette: appPalette,
    palette: {
        primary: { light: green[50], main: "#458B00", dark: '#69b076' },
        secondary: { light: "rgb(232, 245, 233)", main: "#3a87ad", dark: "#005a7e" },
        error: { main: "rgb(244, 67, 54)" },
        text: { primary: "rgb(51, 51, 51)" }
    },
    overrides: {
        MuiTableCell: {
            root: {
                padding: "14px 5px 14px 16px"
            },
            sizeSmall: {
                padding: "5px 12px 5px 12px"
            }
        },
    },
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme
